import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Spinner } from "components/Shared";
import { PageMetadata } from "components/Shared/PageMetadata";
import { useGetCriticalIncidentReferralByExternalId } from "api/queries/criticalIncidentQuery";

export const CIReferralLandingPage: React.FC = () => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });
    const { workOrderId = '' } = useParams();
    const { data: referral, isFetching } = useGetCriticalIncidentReferralByExternalId(workOrderId);

    return  isFetching ? (
        <>
            <PageMetadata
                pageDescription={t('page_description')} 
                pageTitle={t('page_title')}
            />
            <Spinner fillParent />
        </>
    ) : (
        <Navigate to={`/?referralId=${referral?.referralId}`} />
    );
};
